'use strict';

const {__} = wp.i18n;

/**
 * Init All Shortcode Admin Side
 */
class TWER_PAGE_MAP {
  $page_map_zoom_level = null;
  $page_map_zoom_number = null;
  $page_map_custom = null;
  $page_map_initial_point_lat = null;
  constructor() {

    this.$page_map_zoom_level = document.getElementById('page_map_zoom_level');
    this.$page_map_zoom_number = document.getElementById('page_map_zoom_number');
    this.$page_map_custom = document.getElementById('page_map_custom');
    this.$page_map_initial_point_lat =  document.getElementById('page_map_initial_point_lat');

    // Sync zoom range input with zoom range number input
    [
      this.$page_map_zoom_level,
      this.$page_map_zoom_number
    ].map(($element, index, array) => {
      const currentId = $element.id;
      if (currentId === 'page_map_zoom_number') {
        if ($element.value === '') {
          this.$page_map_zoom_level.value = 0;
        } else {
          this.$page_map_zoom_level.value = $element.value;
        }
      }

      if (currentId === 'page_map_zoom_level') {
        if (this.$page_map_zoom_number.value === '') {
          $element.value = 0;
        } else {
          $element.value = this.$page_map_zoom_number.value;
        }
      }
    });

    // Shortcode settings watch
    [
      this.$page_map_zoom_level,
      this.$page_map_zoom_number,
      this.$page_map_initial_point_lat,
      this.$page_map_custom
    ].map(($element, index, array) => {
      const elementType = $element.type;

      switch (elementType) {

        case 'checkbox' :
          if($element.checked) {
            this.$page_map_zoom_level.closest('.js-twer-row').classList.remove('d-none');
            this.$page_map_initial_point_lat.closest('.js-twer-row').classList.remove('d-none');
          } else {
            this.$page_map_zoom_level.closest('.js-twer-row').classList.add('d-none');
            this.$page_map_initial_point_lat.closest('.js-twer-row').classList.add('d-none');
          }

          $element.addEventListener('change', (e) => {
            if($element.checked) {
              this.$page_map_zoom_level.closest('.js-twer-row').classList.remove('d-none');
              this.$page_map_initial_point_lat.closest('.js-twer-row').classList.remove('d-none');
            } else {
              this.$page_map_zoom_level.closest('.js-twer-row').classList.add('d-none');
              this.$page_map_initial_point_lat.closest('.js-twer-row').classList.add('d-none');
            }
          });
          break;
        case 'number' :

          $element.addEventListener('keyup', (e) => {
            if (e.target.id === 'page_map_zoom_number') {
              if (e.target.value === '') {
                this.$page_map_zoom_level.value = 0;

              } else {
                this.$page_map_zoom_level.value = e.target.value;
              }
            }
          });
          break;

        case 'range' :

          $element.addEventListener('input', (e) => {
            this.$page_map_zoom_number.value = e.target.value;
          });
          break;
      }

    });

  }

}

window.addEventListener('DOMContentLoaded', () => {
  new TWER_PAGE_MAP();
});

